var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('router-link',{attrs:{"tag":"p","to":"/Service"}},[_c('span',[_vm._v("查看《服务协议》")]),_c('span',{staticClass:"iconfont"})]),_c('router-link',{attrs:{"tag":"p","to":"/agreeMent"}},[_c('span',[_vm._v("查看《隐私政策》")]),_c('span',{staticClass:"iconfont"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }